/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceActivityRequest {
    getFixupPrototypeFunction() { return InfraResourceActivityRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceActivityRequest>): InfraResourceActivityRequest {
        let obj = Object.assign(new InfraResourceActivityRequest(), model);
        InfraResourceActivityRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceActivityRequest>): InfraResourceActivityRequest {
        if (!model) return null;
        return InfraResourceActivityRequest.newInstance(<InfraResourceActivityRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceActivityRequest) {
        if (!obj) return;

        models.InfraResourceActivityRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceActivityRequest): boolean {
        Object.setPrototypeOf(obj, InfraResourceActivityRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
    }

    /**
     * Tenant ID. Can be fetched from the List Tenants API.
     */
    tenant_id: string;

    /**
     * Unique provider resource identifier.
     */
    resource_id: string;

    /**
     * Category of the resource (e.g. Compute, Storage, Network).
     */
    resource_category: string;

    /**
     * Type of the resource.
     */
    resource_type: string;

    /**
     * Resources of the cloud provider (e.g. Instances, SecurityGroups).
     */
    resource: string;

    /**
     * Start of retention window. Defaults to now minus 90 days.
     */
    start_date: Date;

    /**
     * End of retention window. Defaults to today.
     */
    end_date: Date;

    change_type_filter: Array<models.InfraResourceChangeStatus>;

    /**
     * If provided (1-2 IDs), returns attribute details for these events (Mode 2). If absent, returns paginated timeline (Mode 1).
     */
    event_ids: Array<string>;

    /**
     * Pagination context. Used in Mode 1 only. Default batch_size=25.
     */
    list_context: models.ListContext;

}
